import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Blog() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'すべて' },
    { id: 'news', name: '新着情報' },
    { id: 'construction', name: '建設業許可' },
    { id: 'corporate', name: '会社設立' },
    { id: 'inheritance', name: '相続・遺言' },
    { id: 'immigration', name: '在留資格' },
    { id: 'tips', name: 'お役立ち情報' }
  ];

  const blogPosts = [
    {
      id: 1,
      category: 'news',
      title: 'おかやま行政書士事務所を開設いたしました',
      date: '2026年1月15日',
      image: 'https://public.readdy.ai/ai/img_res/327999cf92ae35339bfc2ad3f6712916.jpg',
      excerpt: 'この度、岡山市北区におかやま行政書士事務所を開設いたしました。地域の皆様の事業と生活をサポートする行政書士として、誠実・迅速・確実なサービスを提供してまいります。',
      content: 'この度、岡山市北区におかやま行政書士事務所を開設いたしました。建設業許可、会社設立、相続手続きなど、幅広い行政手続きをサポートいたします。初回相談は無料ですので、お気軽にご相談ください。'
    },
    {
      id: 2,
      category: 'construction',
      title: '建設業許可の更新手続きについて',
      date: '2026年1月20日',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20construction%20site%20with%20modern%20buildings%20under%20development%20in%20Okayama%2C%20professional%20workers%20in%20safety%20gear%2C%20organized%20construction%20environment%2C%20blue%20sky%2C%20cranes%20visible%2C%20high%20quality%20professional%20photography&width=800&height=500&seq=blog2&orientation=landscape',
      excerpt: '建設業許可は5年ごとに更新が必要です。更新手続きは許可の有効期間満了日の30日前までに行う必要があります。更新手続きの流れと必要書類について解説します。',
      content: '建設業許可の更新手続きについて詳しく解説いたします。更新を忘れると許可が失効してしまいますので、早めの準備が重要です。'
    },
    {
      id: 3,
      category: 'corporate',
      title: '株式会社と合同会社の違いとは？',
      date: '2026年1月25日',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20business%20professionals%20in%20modern%20office%20discussing%20company%20establishment%20documents%2C%20professional%20meeting%20room%2C%20natural%20lighting%2C%20collaborative%20atmosphere%2C%20high%20quality%20professional%20photography&width=800&height=500&seq=blog3&orientation=landscape',
      excerpt: '会社設立を検討する際、株式会社と合同会社のどちらを選ぶべきか迷われる方も多いと思います。それぞれの特徴とメリット・デメリットを比較します。',
      content: '株式会社と合同会社の違いについて、設立費用、運営コスト、信用度などの観点から詳しく解説いたします。'
    },
    {
      id: 4,
      category: 'inheritance',
      title: '相続手続きの流れと期限について',
      date: '2026年2月1日',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20family%20consulting%20with%20professional%20advisor%20about%20inheritance%20documents%20in%20comfortable%20office%2C%20warm%20reassuring%20atmosphere%2C%20natural%20lighting%2C%20trust%20and%20care%20environment%2C%20high%20quality%20professional%20photography&width=800&height=500&seq=blog4&orientation=landscape',
      excerpt: '相続が発生した際、様々な手続きが必要となります。相続放棄は3ヶ月以内、相続税申告は10ヶ月以内など、期限が定められている手続きもあります。',
      content: '相続手続きの全体的な流れと、それぞれの手続きの期限について詳しく解説いたします。'
    },
    {
      id: 5,
      category: 'news',
      title: '営業時間変更のお知らせ',
      date: '2026年2月5日',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20office%20reception%20area%20with%20professional%20signage%2C%20clean%20welcoming%20entrance%2C%20natural%20lighting%2C%20organized%20professional%20environment%2C%20high%20quality%20professional%20photography&width=800&height=500&seq=blog5&orientation=landscape',
      excerpt: '2月より、お客様のご要望にお応えして、営業時間を延長いたします。平日は18時まで営業しておりますので、お仕事帰りのご相談も可能です。',
      content: '2月より営業時間を延長し、より多くのお客様にご利用いただけるようになりました。'
    },
    {
      id: 6,
      category: 'immigration',
      title: '外国人雇用と在留資格について',
      date: '2026年2月10日',
      image: 'https://readdy.ai/api/search-image?query=Diverse%20international%20business%20team%20working%20together%20in%20modern%20Japanese%20office%2C%20multicultural%20professional%20environment%2C%20collaborative%20atmosphere%2C%20natural%20lighting%2C%20high%20quality%20professional%20photography&width=800&height=500&seq=blog6&orientation=landscape',
      excerpt: '外国人を雇用する際には、在留資格の確認が必要です。就労可能な在留資格の種類と、雇用時の注意点について解説します。',
      content: '外国人雇用における在留資格の種類と、企業が注意すべきポイントについて詳しく解説いたします。'
    },
    {
      id: 7,
      category: 'tips',
      title: '飲食店開業に必要な許可とは？',
      date: '2026年2月15日',
      image: 'https://readdy.ai/api/search-image?query=Modern%20stylish%20Japanese%20restaurant%20interior%20in%20Okayama%2C%20elegant%20dining%20space%20with%20wooden%20furniture%2C%20warm%20lighting%2C%20professional%20kitchen%20visible%2C%20welcoming%20atmosphere%2C%20high%20quality%20professional%20photography&width=800&height=500&seq=blog7&orientation=landscape',
      excerpt: '飲食店を開業するには、保健所の営業許可が必要です。また、深夜にお酒を提供する場合は、警察署への届出も必要となります。',
      content: '飲食店開業に必要な各種許可と届出について、手続きの流れとともに詳しく解説いたします。'
    },
    {
      id: 8,
      category: 'tips',
      title: '遺言書の種類と作成方法',
      date: '2026年2月20日',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20elderly%20person%20writing%20important%20documents%20with%20professional%20advisor%20guidance%20in%20comfortable%20office%2C%20warm%20natural%20lighting%2C%20trust%20and%20care%20atmosphere%2C%20high%20quality%20professional%20photography&width=800&height=500&seq=blog8&orientation=landscape',
      excerpt: '遺言書には、自筆証書遺言、公正証書遺言、秘密証書遺言の3種類があります。それぞれの特徴と作成方法について解説します。',
      content: '遺言書の種類とそれぞれのメリット・デメリット、作成時の注意点について詳しく解説いたします。'
    },
    {
      id: 9,
      category: 'construction',
      title: '経営事項審査（経審）とは？',
      date: '2026年2月25日',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20construction%20company%20office%20with%20professional%20staff%20reviewing%20business%20documents%2C%20modern%20corporate%20environment%2C%20organized%20workspace%2C%20natural%20lighting%2C%20high%20quality%20professional%20photography&width=800&height=500&seq=blog9&orientation=landscape',
      excerpt: '公共工事を受注するためには、経営事項審査（経審）を受ける必要があります。経審の評価項目と点数アップのポイントを解説します。',
      content: '経営事項審査の仕組みと、評価を上げるための具体的な方法について詳しく解説いたします。'
    },
    {
      id: 10,
      category: 'corporate',
      title: '会社設立後に必要な届出について',
      date: '2026年3月1日',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20business%20professional%20organizing%20official%20documents%20and%20forms%20at%20modern%20office%20desk%2C%20professional%20attire%2C%20focused%20work%2C%20natural%20lighting%2C%20high%20quality%20professional%20photography&width=800&height=500&seq=blog10&orientation=landscape',
      excerpt: '会社を設立した後、税務署、都道府県税事務所、市町村役場、年金事務所などへの届出が必要です。必要な届出と期限について解説します。',
      content: '会社設立後に必要となる各種届出について、提出先と期限を含めて詳しく解説いたします。'
    },
    {
      id: 11,
      category: 'tips',
      title: '古物商許可の取得方法',
      date: '2026年3月5日',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20second-hand%20shop%20interior%2C%20clean%20organized%20retail%20space%20with%20vintage%20items%20displayed%2C%20professional%20retail%20environment%2C%20warm%20lighting%2C%20high%20quality%20professional%20photography&width=800&height=500&seq=blog11&orientation=landscape',
      excerpt: '中古品の売買を行うには、古物商許可が必要です。リサイクルショップやネットオークションを始める際の許可取得方法を解説します。',
      content: '古物商許可の取得方法と、許可取得後の運営上の注意点について詳しく解説いたします。'
    },
    {
      id: 12,
      category: 'news',
      title: '無料相談会を開催いたします',
      date: '2026年3月10日',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20professional%20consultation%20meeting%20in%20modern%20office%2C%20advisor%20and%20client%20discussing%20documents%20across%20desk%2C%20warm%20welcoming%20atmosphere%2C%20natural%20lighting%2C%20high%20quality%20professional%20photography&width=800&height=500&seq=blog12&orientation=landscape',
      excerpt: '3月20日（土）に、建設業許可・会社設立・相続手続きに関する無料相談会を開催いたします。事前予約制ですので、お早めにお申し込みください。',
      content: '無料相談会の詳細と予約方法についてご案内いたします。お気軽にご参加ください。'
    }
  ];

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || '';
    
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "ホーム",
          "item": siteUrl
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "ブログ・新着情報",
          "item": `${siteUrl}/blog`
        }
      ]
    };

    const blogSchema = {
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "おかやま行政書士事務所 ブログ",
      "description": "行政書士業務に関する最新情報やお役立ち情報を発信しています。",
      "url": `${siteUrl}/blog`,
      "publisher": {
        "@type": "Organization",
        "name": "おかやま行政書士事務所",
        "logo": {
          "@type": "ImageObject",
          "url": `${siteUrl}/logo.png`
        }
      },
      "blogPost": blogPosts.slice(0, 5).map(post => ({
        "@type": "BlogPosting",
        "headline": post.title,
        "description": post.excerpt,
        "datePublished": post.date,
        "author": {
          "@type": "Person",
          "name": "岡山太郎"
        },
        "publisher": {
          "@type": "Organization",
          "name": "おかやま行政書士事務所"
        }
      }))
    };

    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.text = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'application/ld+json';
    script2.text = JSON.stringify(blogSchema);
    document.head.appendChild(script2);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  const filteredPosts = selectedCategory === 'all' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative h-[500px] sm:h-[600px] lg:h-[500px] bg-gradient-to-r from-blue-900 to-blue-700 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')]"></div>
        </div>
        <div className="relative h-full flex items-center">
          <div className="w-full max-w-7xl mx-auto px-6 lg:px-8">
            <div className="max-w-3xl">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-4 sm:mb-6">ブログ・新着情報</h1>
              <p className="text-base sm:text-lg lg:text-xl text-white/90 leading-relaxed">
                行政書士業務に関する最新情報やお役立ち情報を発信しています。岡山市での許認可申請や会社設立、相続手続きなどの情報をご覧ください。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-4 sm:py-6 lg:py-8 bg-gray-50 sticky top-16 sm:top-20 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-2 sm:gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-4 sm:px-6 py-2 sm:py-2.5 rounded-full text-sm sm:text-base font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category.id
                    ? 'bg-blue-600 text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {filteredPosts.map((post) => (
              <article key={post.id} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                <div className="h-48 sm:h-56 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-4 sm:p-6">
                  <div className="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
                    <span className="px-2 sm:px-3 py-0.5 sm:py-1 bg-blue-100 text-blue-700 text-xs font-semibold rounded-full whitespace-nowrap">
                      {categories.find(c => c.id === post.category)?.name}
                    </span>
                    <span className="text-xs sm:text-sm text-gray-500">{post.date}</span>
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 line-clamp-2">
                    {post.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed line-clamp-3 mb-3 sm:mb-4">
                    {post.excerpt}
                  </p>
                  <button className="flex items-center gap-2 text-blue-600 text-sm sm:text-base font-semibold hover:text-blue-700 transition-colors cursor-pointer whitespace-nowrap">
                    続きを読む
                    <i className="ri-arrow-right-line text-base sm:text-lg"></i>
                  </button>
                </div>
              </article>
            ))}
          </div>

          {filteredPosts.length === 0 && (
            <div className="text-center py-12 sm:py-20">
              <i className="ri-file-list-line text-5xl sm:text-6xl text-gray-300 mb-4"></i>
              <p className="text-lg sm:text-xl text-gray-500">該当する記事がありません</p>
            </div>
          )}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-blue-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-6 sm:mb-8">
            <i className="ri-mail-line text-5xl sm:text-6xl text-white mb-4"></i>
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 sm:mb-6">
            最新情報をお届けします
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-white/90 mb-8 sm:mb-10">
            行政書士業務に関する最新情報やお役立ち情報を定期的に発信しています。<br className="hidden sm:block" />
            お気軽にお問い合わせください。
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <a
              href="tel:0860123456"
              className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-white text-blue-600 text-base sm:text-lg font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill mr-2 sm:mr-3 text-xl sm:text-2xl"></i>
              086-012-3456
            </a>
            <a
              href="/#contact"
              className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-blue-700 text-white text-base sm:text-lg font-semibold rounded-lg hover:bg-blue-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-fill mr-2 sm:mr-3 text-xl sm:text-2xl"></i>
              お問い合わせフォーム
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}